<template>
  <b-form v-on:submit.prevent="submit()" validated novalidateenc type="multipart/form-data">
    <b-card>
      <div slot="header">
        {{title}}
      </div>
      <b-card-body>
        <b-form-group label-for="Name" label="Name">
          <b-form-input type="text" v-model="adForm.name" class="form-control-warning" id="Name" required></b-form-input>
          <b-form-valid-feedback>
            Valid name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter ad name.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="Type" label="Type">
          <b-form-select id="Type"
                :options="typeList"
                required
                v-model="adForm.type">
          </b-form-select>
          <b-form-valid-feedback>
            Valid type provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Select type.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="file" label="Image" v-if="showImageUpload">
          <input type="file" id="file" name="file" ref="file"  class="form-control" />
        </b-form-group>
        <b-form-group label-for="file" label="Image" v-if="showHtmlEditor">
          <vue-editor v-model="adForm.html"></vue-editor>
        </b-form-group>
        <b-form-group label-for="Link" label="Link" v-if="showImageUpload">
          <b-form-input type="text" v-model="adForm.link" class="form-control-warning" id="Link" required></b-form-input>
          <b-form-valid-feedback>
            Valid link provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter ad link.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="Delay" label="Delay">
          <b-form-input type="number" v-model.number="adForm.delay" class="form-control-warning" style="width: 80px;" id="Delay" required></b-form-input>
          <b-form-valid-feedback>
            Valid delay provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter ad delay.
          </b-form-invalid-feedback>
        </b-form-group>
        <Allocation :adForm="adForm" :hideCompany="hideCompany" :isEdit="isEdit"></Allocation>
        <div class="float-right">
          <a href="#" @click.prevent="noStart(adForm)">No start date</a>
        </div>
        <b-form-group label-for="StartDate" label="Start Date">
          <datepicker v-model="adForm.startDate" name="StartDate" :input-class="'form-control input-cal'"></datepicker>
        </b-form-group>
        <div class="float-right">
          <a href="#" @click.prevent="noExpiry(adForm)">No expiry date</a>
        </div>
        <b-form-group label-for="ExpiryDate" label="Expiry Date">
          <datepicker v-model="adForm.expiryDate" name="ExpiryDate" :input-class="'form-control input-cal'"></datepicker>
        </b-form-group>
        <b-form-checkbox v-model="adForm.enabled">Enabled</b-form-checkbox>
      </b-card-body>
      <div slot="footer" class="text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/ads/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-card>
  </b-form>
</template>
<script>
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Allocation from '@/views/admin/Allocation'
import Datepicker from 'vuejs-datepicker'
import common from './../../mixins/common'

export default {
  name: 'formad',
  components: {
    VueEditor,
    Allocation,
    Datepicker
  },
  data () {
    return {
      adForm: {}
    }
  },
  mixins: [common],
  props: ['title','form','mode'],
  computed: {
    typeList: function () {
      let types = [];
      types.push({text: 'Image', value: 'image'});
      types.push({text: 'HTML', value: 'html'});
      return types;
    },
    isEdit: function () {
      return this.mode === 'edit'
    },
    showImageUpload () {
      return this.adForm.type === 'image';
    },
    showHtmlEditor () {
      return this.adForm.type === 'html';
    }
  },
  methods: {
    submit: function () {

      let scope = this; 

      if(!scope.adForm.name) {
        console.log('invalid')
        return
      }
      
      if(!scope.adForm.type) {
        console.log('invalid')
        return
      }

      if(!scope.adForm.delay) {
        console.log('invalid')
        return
      }

      if(!scope.adForm.company) {
        console.log('invalid')
        return
      }

      if(scope.adForm.type === 'image') {
        scope.adForm.file = this.$refs.file.files[0];
        if(scope.adForm.file) {
          scope.adForm.imageExt = scope.adForm.file.name.split('.').pop();
        }
        scope.adForm.html = null;
      }

      scope.adForm.expiryDate = scope.prepareDate(scope.adForm.expiryDate);
      
      this.$emit('submit', scope.adForm);
    }
  },
  created () {
    if(!this.isEdit) {
      this.adForm = this.form;
    }
  },
  watch: {
    form (val) {
      this.adForm = this.form;
      if(this.adForm.region === undefined) {
        this.adForm.region = null;
      }
      if(this.adForm.branch === undefined) {
        this.adForm.branch = null;
      }
      if(this.adForm.device === undefined) {
        this.adForm.device = null;
      }
    }
  }
}
</script>
